import React, { useState } from 'react';
import {
    Typography,
    Dialog,
    DialogContent,
    CircularProgress,
    Grid,
    Paper,
    Button
} from '@material-ui/core';
import logo from '../images/zedeid_logo.png';
import SecurityIcon from '@material-ui/icons/Security';
import PillLabel from './ui/PillLable';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LaunchIcon from '@material-ui/icons/Launch';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useDispatch } from 'react-redux';
import { setView } from '../redux/appSlice';

const youtube_video_id = process.env.REACT_APP_YOUTUBE_ID ?? '';

export default function Home() {
    const dispatch = useDispatch();
    const [videoOpen, setVideoOpen] = useState(false);
    const [videoLoading, setVideoLoading] = useState(false);
    const [videoHovered, setVideoHovered] = useState(false);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <div
                            style={{
                                display: 'flex',
                                gap: 32,
                                alignItems: 'stretch',
                                flexWrap: 'wrap'
                            }}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <img
                                    src={logo}
                                    alt="logo"
                                    style={{
                                        display: 'block',
                                        width: 'clamp(160px, 15vw, 280px)',
                                        height: 'auto'
                                    }}
                                />
                                <div
                                    style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 'clamp(24px, 5vw, 48px)' }}>
                                    <Button
                                        onClick={() => dispatch(setView(4))}
                                        endIcon={<ArrowForwardIcon style={{ fontSize: 15 }} />}
                                        style={{
                                            backgroundColor: '#2ec4b6',
                                            color: '#ffffff',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            borderRadius: 8,
                                            padding: '10px 20px',
                                            fontFamily: "'DM Mono', monospace",
                                            border: '1.5px solid #2ec4b6',
                                            transition: 'transform 0.15s ease, box-shadow 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            (e.currentTarget as HTMLElement).style.transform =
                                                'translateY(-1px)';
                                            (e.currentTarget as HTMLElement).style.backgroundColor =
                                                '#fff';
                                            (e.currentTarget as HTMLElement).style.color = '#2ec4b6';
                                        }}
                                        onMouseLeave={(e) => {
                                            (e.currentTarget as HTMLElement).style.transform =
                                                'translateY(0)';
                                            (e.currentTarget as HTMLElement).style.backgroundColor =
                                                '#2ec4b6';
                                            (e.currentTarget as HTMLElement).style.color = '#fff';
                                        }}>
                                        Try Credential Studio
                                    </Button>
                                    <Button
                                        href="https://zedeid.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        endIcon={<LaunchIcon style={{ fontSize: 15 }} />}
                                        style={{
                                            border: '1.5px solid #2ec4b6',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            borderRadius: 8,
                                            color: '#2ec4b6',
                                            backgroundColor: 'transparent',
                                            padding: '10px 20px',
                                            fontFamily: "'DM Mono', monospace",
                                            transition:
                                                'transform 0.15s ease, border-color 0.15s ease, color 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            (e.currentTarget as HTMLElement).style.transform =
                                                'translateY(-1px)';
                                            (e.currentTarget as HTMLElement).style.backgroundColor =
                                                '#2ec4b6';
                                            (e.currentTarget as HTMLElement).style.color = '#fff';
                                        }}
                                        onMouseLeave={(e) => {
                                            (e.currentTarget as HTMLElement).style.transform =
                                                'translateY(0)';
                                            (e.currentTarget as HTMLElement).style.backgroundColor =
                                                'transparent';
                                            (e.currentTarget as HTMLElement).style.color = '#2ec4b6';
                                        }}>
                                        Visit zedeid.com
                                    </Button>
                                </div>
                            </div>

                            <div
                                style={{
                                    flex: 1,
                                    minWidth: 260,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 16
                                }}>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <PillLabel
                                style={{
                                    width: 'auto',
                                    alignSelf: 'flex-start',
                                    whiteSpace: 'nowrap',
                                    color: '#1a3a36',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: 600
                                }}>
                                <span
                                    style={{
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: '#2ec4b6',
                                        flexShrink: 0
                                    }}></span>
                                Decentralized Identities
                            </PillLabel>
                            <PillLabel
                                style={{
                                    width: 'auto',
                                    alignSelf: 'flex-start',
                                    whiteSpace: 'nowrap',
                                    color: '#1a3a36',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: 600
                                }}>
                                <span
                                    style={{
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: '#2ec4b6',
                                        flexShrink: 0
                                    }}></span>
                                Verifiable Credentials
                            </PillLabel>
                            </div>

                            <Typography
                                style={{
                                    fontSize: 15,
                                    color: '#5a6272',
                                    lineHeight: 1.7
                                }}>
                                ZeDeId Tools is a browser-based toolkit for working with
                                decentralized digital identities and verifiable credentials — no
                                servers, no sign-ups, nothing ever leaves your device.
                                <br />
                                <br />
                                Manage <strong>Decentralized Identifiers (DIDs)</strong>: create
                                standard or hierarchical-deterministic DIDs from mnemonic seeds,
                                resolve any DID to its full document, and update or revoke
                                off-chain DIDs using cryptographic proof of ownership.
                                <br />
                                <br />
                                Use <strong>Credential Studio</strong> to issue tamper-evident
                                Verifiable Credentials over any subject you define, then compose
                                selective-disclosure Verifiable Presentations — letting holders
                                reveal only the claims they choose. Verifiers can instantly confirm
                                issuer and holder signatures and detect any unauthorized
                                modifications to the credential data.
                                <br />
                                <br />
                                Every cryptographic operation runs entirely in your browser.
                            </Typography>

                        </div>
                    </div>
                    </Grid>

                    <Grid
                        item
                        xs={12}>
                        <div
                            onClick={() => {
                                setVideoOpen(true);
                                setVideoLoading(true);
                            }}
                            onMouseEnter={() => setVideoHovered(true)}
                            onMouseLeave={() => setVideoHovered(false)}
                            style={{
                                width: '100%',
                                maxWidth: 800,
                                margin: '0 auto',
                                border: '1px solid #e0e0e0',
                                borderRadius: 10,
                                overflow: 'hidden',
                                cursor: 'pointer',
                                backgroundColor: '#f9f9f9'
                            }}>
                            <div
                                style={{
                                    position: 'relative',
                                    paddingBottom: '56.25%',
                                    backgroundImage: `url(https://img.youtube.com/vi/${youtube_video_id}/maxresdefault.jpg)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    transform: 'scale(1.04)'
                                }}>
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: videoHovered
                                            ? 'rgba(0,0,0,0.15)'
                                            : 'transparent',
                                        transition: 'background-color 0.2s ease'
                                    }}>
                                    <YouTubeIcon
                                        style={{
                                            color: '#FF0033',
                                            fontSize: 64,
                                            transform: videoHovered ? 'scale(1.18)' : 'scale(1)',
                                            filter: videoHovered
                                                ? 'drop-shadow(0 0 10px rgba(36,195,181,0.7))'
                                                : 'none',
                                            transition: 'transform 0.2s ease, filter 0.2s ease'
                                        }}
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    padding: '7px 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    textAlign: 'center',
                                    backgroundColor: '#f4f4f4',
                                    borderTop: '1px solid rgba(0,0,0,0.08)'
                                }}>
                                <Typography
                                    style={{
                                        fontSize: '0.65rem',
                                        color: '#67827e',
                                        fontWeight: 600,
                                        paddingTop: 4
                                    }}>
                                    How to use Credential Studio?
                                </Typography>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4
                                    }}>
                                    <Typography
                                        style={{
                                            fontSize: '0.65rem',
                                            color: '#67827e',
                                            fontWeight: 600,
                                            lineHeight: 1,
                                            paddingTop: 4
                                        }}>
                                        1 minute walkthrough
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Paper
                    elevation={0}
                    style={{
                        border: '1px solid #2ec4b6',
                        borderRadius: 12,
                        overflow: 'hidden'
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '10px 20px',
                            backgroundColor: '#e8f8f5',
                            borderBottom: '1px solid #2ec4b6'
                        }}>
                        <SecurityIcon style={{ fontSize: 16, color: '#1baa8a' }} />
                        <Typography
                            style={{
                                fontSize: 11,
                                fontWeight: 600,
                                color: '#1baa8a',
                                textTransform: 'uppercase',
                                letterSpacing: '0.2em',
                                fontFamily: "'DM Mono', monospace"
                            }}>
                            Privacy Guaranteed
                        </Typography>
                    </div>
                    <div style={{ padding: '16px 20px' }}>
                        <Typography
                            variant="body2"
                            style={{ fontSize: 14, lineHeight: 1.7, color: '#5a6272' }}>
                            When you are on this website, none of the info you see or generate
                            leaves your browser, meaning it is perfectly secure and safe to use
                            these services.
                        </Typography>
                    </div>
                </Paper>
                <Typography
                    variant="caption"
                    style={{
                        display: 'block',
                        textAlign: 'right',
                        color: '#c0c0c0',
                        fontSize: 11
                    }}>
                    {process.env.REACT_APP_VERSION}
                </Typography>
            </Grid>

            {/* Video dialog */}
            <Dialog
                open={videoOpen}
                onClose={() => {
                    setVideoOpen(false);
                    setVideoLoading(false);
                }}
                maxWidth="md"
                fullWidth>
                <DialogContent style={{ padding: 0, overflow: 'hidden', backgroundColor: '#000' }}>
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                        {videoLoading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 12
                                }}>
                                <CircularProgress style={{ color: '#24c3b5' }} />
                                <Typography style={{ color: '#fff', fontSize: '0.85rem' }}>
                                    Preparing video...
                                </Typography>
                            </div>
                        )}
                        <iframe
                            src={`https://www.youtube.com/embed/${youtube_video_id}?autoplay=1&rel=0&modestbranding=1&controls=1&fs=1`}
                            title="How to use Credential Studio"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => setVideoLoading(false)}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'block',
                                border: 0
                            }}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </Grid>
    );
}
